export class itemSelect {
    public name: string;
    public value: any;
    public selected?: boolean;
}

export class itemSelectObject {
    public name: string;
    public id: any;
}

export const surveyType: itemSelect[] = [
    { name: 'MOBILE', value: 1 },
    { name: 'ESPECIAL', value: 2 },
    { name: 'TRADICIONAL', value: 3 },
    { name: 'VISTORIA ACOMPANHADA', value: 4 }

];

export const segment: itemSelect[] = [
    { name: '1 - Veículo', value: 1 },
    { name: '2 - Motocicleta', value: 2 },
    { name: '3 - Caminhão', value: 3 },
    { name: '4 - Vans e Vucs', value: 4 },
    { name: '5 - Semi Reboque', value: 5 },
    { name: '6 - Bike', value: 6 }
]

export const mediaType: itemSelect[] = [
    { name: 'FOTO', value: 1 },
    { name: 'VIDEO', value: 2 },
    { name: 'FOTO/VIDEO', value: 3 }
]

export const uf: itemSelect[] = [
    { name: 'AC', value: 'AC' },
    { name: 'AL', value: 'AL' },
    { name: 'AP', value: 'AP' },
    { name: 'AM', value: 'AM' },
    { name: 'BA', value: 'BA' },
    { name: 'CE', value: 'CE' },
    { name: 'DF', value: 'DF' },
    { name: 'ES', value: 'ES' },
    { name: 'GO', value: 'GO' },
    { name: 'MA', value: 'MA' },
    { name: 'MT', value: 'MT' },
    { name: 'MS', value: 'MS' },
    { name: 'MG', value: 'MG' },
    { name: 'PA', value: 'PA' },
    { name: 'PB', value: 'PB' },
    { name: 'PR', value: 'PR' },
    { name: 'PE', value: 'PE' },
    { name: 'PI', value: 'PI' },
    { name: 'RJ', value: 'RJ' },
    { name: 'RN', value: 'RN' },
    { name: 'RS', value: 'RS' },
    { name: 'RO', value: 'RO' },
    { name: 'RR', value: 'RR' },
    { name: 'SC', value: 'SC' },
    { name: 'SP', value: 'SP' },
    { name: 'SE', value: 'SE' },
    { name: 'TO', value: 'TO' }
]

export const customer: itemSelectObject[] = [
    { name: 'Seguradora Sura', id: '229a8f96-2d04-41c7-b498-ae8698690066' }
]
